import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import {
  StyledList,
  StyledNeedHelp,
  StyledText,
  StyledH3,
  StyledListItem,
} from '../../../pages/UploadDocuments/UploadDocuments.styles';
import { UPLOAD_DOCUMENTS_FLOW_STEPS } from '../../../shared/constants';
import { StyledStepsInfoBox, StyledSidebar } from './SideBar.styles';

const SideBar = ({ mobile }: { mobile?: boolean }): JSX.Element => {
  const { t } = useTranslation(['common', 'documentsflow']);

  const { step } = useParams();

  return (
    <StyledSidebar lg={3} mobile={mobile ?? false}>
      <StyledStepsInfoBox>
        <div>
          <StyledH3
            tenant={step === UPLOAD_DOCUMENTS_FLOW_STEPS.VERIFY_IDENTITY}
            completed={step !== UPLOAD_DOCUMENTS_FLOW_STEPS.VERIFY_IDENTITY}
          >
            {upperFirst(t('verifyIdentity'))}
          </StyledH3>
          {step === UPLOAD_DOCUMENTS_FLOW_STEPS.VERIFY_IDENTITY && (
            <>
              <StyledText>
                {upperFirst(t('uploadFollowingDocuments'))}
              </StyledText>
              <StyledList>
                <StyledListItem>
                  <StyledText black>
                    {upperFirst(t('identityDocument'))}
                  </StyledText>
                </StyledListItem>
                <StyledListItem>
                  <StyledText black>{upperFirst(t('fiscalCode'))}</StyledText>
                </StyledListItem>
              </StyledList>
            </>
          )}
        </div>
        <div>
          {step !== UPLOAD_DOCUMENTS_FLOW_STEPS.VERIFY_IDENTITY && (
            <>
              <StyledH3
                tenant={
                  step === UPLOAD_DOCUMENTS_FLOW_STEPS.ADD_A_GUARANTOR ||
                  step ===
                    UPLOAD_DOCUMENTS_FLOW_STEPS.UPLOAD_GUARANTOR_DOCUMENTS ||
                  step ===
                    UPLOAD_DOCUMENTS_FLOW_STEPS.ADD_ANOTHER_GUARANTOR_OR_FINISH
                }
                completed={
                  step === UPLOAD_DOCUMENTS_FLOW_STEPS.WAIT_FOR_CONFIRMATION
                }
              >
                {upperFirst(t('reachTheMeritShare'))}
              </StyledH3>
              {(step === UPLOAD_DOCUMENTS_FLOW_STEPS.ADD_A_GUARANTOR ||
                step ===
                  UPLOAD_DOCUMENTS_FLOW_STEPS.UPLOAD_GUARANTOR_DOCUMENTS ||
                step ===
                  UPLOAD_DOCUMENTS_FLOW_STEPS.ADD_ANOTHER_GUARANTOR_OR_FINISH) && (
                <>
                  <StyledText>
                    {upperFirst(t('documentsflow:checkThatYouCanPayTheRent'))}
                  </StyledText>
                  <StyledList>
                    <StyledListItem>
                      <StyledText black>
                        {upperFirst(t('addOneOrMoreGuarantors'))}
                      </StyledText>
                      <StyledText>
                        {upperFirst(t('helpAchievingGuarantees'))}
                      </StyledText>
                    </StyledListItem>
                    <StyledListItem>
                      <StyledText black>
                        {upperFirst(t('uploadIncomeDocuments'))}
                      </StyledText>
                      <StyledText>
                        {upperFirst(t('forEachAddedGuarantor'))}
                      </StyledText>
                    </StyledListItem>
                  </StyledList>
                </>
              )}
            </>
          )}
        </div>
      </StyledStepsInfoBox>
      <StyledNeedHelp>
        <StyledText black>
          <strong>{upperFirst(t('documentsflow:needHelp'))}</strong>
        </StyledText>
        <a href={`mailto:assistenza@zappyrent.com`}>assistenza@zappyrent.com</a>
      </StyledNeedHelp>
    </StyledSidebar>
  );
};

export default SideBar;
